
jQuery(function($) {
	var banner = $('#cookie-banner'),
		accept = $('#cookie-banner-accept'),
		decline = $('#cookie-banner-decline');

	if(!$.cookie.get('cookiePrefs')) {
		banner.addClass('show');
	}

	accept.click(function() {
		$.cookie.set('cookiePrefs', 'accept', 365);
		banner.removeClass('show');
	});

	decline.click(function() {
		$.cookie.set('cookiePrefs', 'decline', 365);
		banner.removeClass('show');
	});
});
jQuery(function($) {
    $('#submissions').on('click', '.submission-list-item__link[data-panel]', function(e) {
        e.preventDefault();

        var active = $('#' + $(this).data('panel')),
            panel = active.closest('.panel');

        if(active.is(':visible')) {
            active.slideUp(250, function() {
                panel.hide();
            });
        } else {
            $('.submission-list-item__panels > .panel').not(panel).slideUp(450);
            $('.submission-list-item__panel').not(active).slideUp(450);
            panel.show();
            active.slideDown(450, function() {
                active.trigger('listItemPanel:open');
            });
        }
    });


    $('.submission-list-item__message-panel').on('listItemPanel:open', function() {
        var panel = $(this),
            action = panel.data('post-url');

        if(action) $.post(action, {token: csrfToken});
    });

    // Make 'EDIT' buttons open in new window if in lightbox
    $(document).on('click', '.edit-submission-button', function(e) {
        var clicked = $(this),
            submissionId = clicked.data('submission-id');
        if(cph.isInLitbox(clicked)) {
            e.preventDefault();
            window.open(clicked.attr('href'), 'editSubmission' + submissionId);
        }
    });
});